import { TransportMode } from '@/features/shipments'

import { ICurrency } from './Currency/CurrencyModel'
import { InvoiceClaim } from './invoiceClaim'

export enum InvoiceStatus {
  OUTSTANDING = 'Outstanding',
  OVERDUE = 'Overdue',
  PAID = 'Paid',
  CANCELED = 'Cancelled',
  CLEARED = 'Cleared',
}

export type InvoiceType =
  | 'freightHubInvoice'
  | 'freightHubAdditionalCharge'
  | 'freightHubCustomsInvoice'
  | 'freightHubAdvanceInvoice'
  | 'freightHubCreditNote'
  | 'intercompanyInvoice'
  | 'freightHubOriginInvoice'
  | 'transportInvoiceFinal'

export type Invoice = {
  _id: string
  createdAt: string
  customer_id: string
  name: string
  internal: boolean
  userProvided: boolean
  role: InvoiceType
  file: string
  mimeType: string
  shipmentId: string
  invoiceNumber: string
  invoiceStatus?: InvoiceStatus
  dueDate?: string
  amount?: number
  dueAmount?: number
  invoiceAmount?: ICurrency
  invoiceDueAmount?: ICurrency
  customerReference?: string
  transportMode: TransportMode
}

export type InvoiceWithClaim = Invoice & { claim: InvoiceClaim | undefined }
